import Vue from "vue";
import DetailView from "@/views/DetailView/DetailView.vue";
import Vuetify from "vuetify/lib";
import appStore from "./store/appStore";
import de from "vuetify/es5/locale/de";
import en from "vuetify/es5/locale/en";
import { getURLParamsObject } from "@/helpers/commonHelper";

Vue.config.productionTip = false;
Vue.use(Vuetify);

// loading wrapper for each instance
const $elements = document.getElementsByClassName("eoev-dv-widget");
const savedElements = []; // save elements to array, since array will otherwise be reduce while looping
for (let i = 0; i < $elements.length; i++) {
  savedElements.push($elements[i]);
}

const colorConfig = getURLParamsObject(true);

for (let i = 0; i < savedElements.length; i++) {
  const $el = savedElements[i];

  const locale =
    ($el.attributes["data-locale"] && $el.attributes["data-locale"].value) ||
    "de-de";

  const getColor = (key, defaultValue) =>
    $el.attributes[`data-${key}`]?.value || colorConfig?.[key] || defaultValue;

  // build vuetify instance using certain colors
  const opts = {
    icons: {
      iconfont: "mdiSvg"
    },
    theme: {
      themes: {
        light: {
          primary: getColor("color-primary", "#97bd0f"),
          secondary: getColor("color-secondary", "#5d7114"),
          accent: getColor("color-accent", "#2468c9"),
          error: getColor("color-error", "#c55c52"),
          info: getColor("color-info", "#314d57"),
          success: getColor("color-success", "#97bd0f"),
          warning: getColor("color-warning", "#e2d7af")
        }
      }
    },
    lang: {
      locales: { de, en },
      current: locale
    }
  };
  const vuetify = new Vuetify(opts);

  // do we have initial data?
  const data = $el.querySelector(".eoev-dv-widget-initial-data");
  const settings = $el.querySelector(".eoev-dv-widget-settings");
  const categories = $el.querySelector(".eoev-dv-widget-categories");
  const features = $el.querySelector(".eoev-dv-widget-features");

  // set as constants to avoid overwriting of settings below
  const id = $el.attributes.id && $el.attributes.id.value;
  const eventId =
    $el.attributes["data-event"] && $el.attributes["data-event"].value;
  const momentId =
    $el.attributes["data-moment"] && $el.attributes["data-moment"].value;
  const namespace =
    ($el.attributes["data-namespace"] &&
      $el.attributes["data-namespace"].value) ||
    "eoev";

  // create store
  const store = appStore(namespace, {
    targetUri:
      $el.attributes["data-target-uri"] &&
      $el.attributes["data-target-uri"].value,
    listUri:
      $el.attributes["data-list-uri"] && $el.attributes["data-list-uri"].value,
    apiUrl:
      $el.attributes["data-api-url"] && $el.attributes["data-api-url"].value,
    apiKey:
      $el.attributes["data-api-key"] && $el.attributes["data-api-key"].value,
    textColor: getColor("color-text", "#333"),
    mapPinFillColor: getColor("map-pin-fill-color", "#257eca"),
    mapPinStrokeColor: getColor("map-pin-stroke-color", "#2d5069"),
    mapPinFillColorActive: getColor("map-pin-fill-color-active", "#c55c52"),
    mapPinStrokeColorActive: getColor("map-pin-stroke-color-active", "#5d332f")
  });

  new Vue({
    vuetify,
    store,
    render: function(h) {
      return h(DetailView, {
        props: {
          id: id,
          "event-id": eventId,
          "moment-id": momentId,
          // 'first-day-of-week': firstDayOfWeek,
          "initial-data": (data && JSON.parse(data.innerHTML)) || undefined,
          "initial-settings":
            (settings && JSON.parse(settings.innerHTML)) || undefined,
          "initial-categories":
            (categories && JSON.parse(categories.innerHTML)) || undefined,
          "initial-features":
            (features && JSON.parse(features.innerHTML)) || undefined
        }
      });
    }
  }).$mount($el);
}
